var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a, _b;
import React, { useState, useMemo, useEffect, useCallback } from 'react';
import { Avatar, Box, Collapse, Divider, Popover, Tooltip, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import HowToRegOutlinedIcon from '@mui/icons-material/HowToRegOutlined';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import SettingsIcon from '@mui/icons-material/Settings';
import { NavigationConfig } from '../../utils/navigation_config';
import constants from '../../config/constants';
import SideMenuWrapper from './LeftMenuStyles';
import { baseColors } from '../../Themes/colors';
import { DashboardIcon, PortalSetupIcon, } from './../icons';
import { loginSignup_asyncActions } from '../../asyncActions/loginSignup_asynActions';
import { fetchAppMetadata } from '../../utils/appMetadata';
import { formatPhoneNumber } from '../../utils/commonUtilities';
import ConfirmationAndInformationPoup, { POPUP_TYPE } from '../UtilityComponents/ConfirmationAndInformationPoup';
var isProduction = process.env.NODE_ENV === constants.ENV.PRODUCTION && !((_b = (_a = process.env.API_DOMAIN) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes('uat'));
var defaultTabs = [
    'Main',
    'Financing & Adjustments',
    'Billing & Payment Schedule',
    'EFT Assignment',
    'UDFs (User Defined Fields)',
    'Documents Management',
    'Equipment (Assets)',
    'Schedule Billables',
    'Accounts Payable',
    'Liens',
    'Insurance Management',
    'Reports',
];
var isAnyActionEnabled = function (permission) {
    return (permission.View === 1 ||
        permission.Add === 1 ||
        permission.Update === 1 ||
        permission.Delete === 1);
};
var isPathActive = function (pathname, path, additionalPaths) {
    var lower = pathname.toLowerCase();
    if (path && lower.startsWith(path.toLowerCase()))
        return true;
    if (additionalPaths)
        return additionalPaths.some(function (p) { return lower.startsWith(p.toLowerCase()); });
    return false;
};
var isPathInTree = function (pathname, items) {
    if (items === void 0) { items = []; }
    return items.some(function (item) {
        var _a;
        if (isPathActive(pathname, item.path, item.additionalPaths)) {
            return true;
        }
        return ((_a = item.submenuItems) === null || _a === void 0 ? void 0 : _a.length)
            ? isPathInTree(pathname, item.submenuItems)
            : false;
    });
};
var findActiveSubKey = function (pathname, items, parentPath) {
    var _a;
    for (var index = 0; index < items.length; index += 1) {
        var item = items[index];
        var key = "".concat(parentPath, "-").concat(index);
        if (isPathActive(pathname, item.path)) {
            return key;
        }
        if ((_a = item.submenuItems) === null || _a === void 0 ? void 0 : _a.length) {
            var nestedKey = findActiveSubKey(pathname, item.submenuItems, key);
            if (nestedKey) {
                return nestedKey;
            }
        }
    }
    return null;
};
var collectActiveBranchKeys = function (pathname, items, parentPath) {
    return items.reduce(function (keys, item, index) {
        var _a;
        if (!((_a = item.submenuItems) === null || _a === void 0 ? void 0 : _a.length)) {
            return keys;
        }
        var key = "".concat(parentPath, "-").concat(index);
        var hasActiveChild = isPathInTree(pathname, item.submenuItems);
        if (isPathActive(pathname, item.path) || hasActiveChild) {
            keys.push.apply(keys, __spreadArray([key], collectActiveBranchKeys(pathname, item.submenuItems, key), false));
        }
        return keys;
    }, []);
};
var filterMenuItemsByPermissions = function (items, canView) {
    return items.reduce(function (accumulator, item) {
        var _a;
        if (!canView(item.permissionKey)) {
            return accumulator;
        }
        if ((_a = item.submenuItems) === null || _a === void 0 ? void 0 : _a.length) {
            var filteredChildren = filterMenuItemsByPermissions(item.submenuItems, canView);
            if (!filteredChildren.length) {
                return accumulator;
            }
            accumulator.push(__assign(__assign({}, item), { submenuItems: filteredChildren }));
            return accumulator;
        }
        accumulator.push(item);
        return accumulator;
    }, []);
};
var getIcon = function (label, isCustomerPortal) {
    if (isCustomerPortal === void 0) { isCustomerPortal = false; }
    if (isCustomerPortal) {
        switch (label) {
            case 'Dashboard': return React.createElement("span", { className: "icon-Card" });
            case 'Customer Management': return React.createElement("span", { className: "icon-profile" });
            case 'Payment Management': return React.createElement("span", { className: "icon-credit-card" });
            case 'Document Management': return React.createElement("span", { className: "icon-landscape-document" });
            case 'Support Management': return React.createElement("span", { className: "icon-question" });
            case 'Brand Customization': return React.createElement("span", { className: "icon-color-palette" });
            case 'Chatbot FAQs': return React.createElement(ChatBubbleOutlineOutlinedIcon, { sx: { color: '#FFFFFF', fontSize: 24 } });
            case 'Audit Logs': return React.createElement(FactCheckOutlinedIcon, { sx: { color: '#FFFFFF', fontSize: 24 } });
            case 'Admin Registration': return React.createElement(HowToRegOutlinedIcon, { sx: { color: '#FFFFFF', fontSize: 24 } });
            default: return null;
        }
    }
    switch (label) {
        case 'Dashboard': return React.createElement(DashboardIcon, { isDarkMode: false });
        case 'Application Management': return React.createElement("span", { className: "icon-file" });
        case 'User Management': return React.createElement("span", { className: "icon-Management" });
        case 'Administrator': return React.createElement("span", { className: "icon-shield-check" });
        case 'Admin Management': return React.createElement("span", { className: "icon-shield-check" });
        case 'Admin Users': return React.createElement("span", { className: "icon-shield-check" });
        case 'Roles & Permissions': return React.createElement("span", { className: "icon-shield-check" });
        case 'Portal Setup': return React.createElement(PortalSetupIcon, null);
        case 'Global Settings': return React.createElement(SettingsIcon, null);
        case 'Marketing Content': return React.createElement("span", { className: "icon-campaign" });
        case 'Resubmit': return React.createElement("span", { className: "icon-Reload" });
        case 'Customer Portal': return React.createElement("span", { className: "icon-users" });
        default: return null;
    }
};
var LeftMenu = function (_a) {
    var _b, _c, _d, _e, _f;
    var title = _a.title, subtitle = _a.subtitle, id = _a.id, _g = _a.tabs, tabs = _g === void 0 ? defaultTabs : _g, onTabChange = _a.onTabChange, _h = _a.selectedTab, selectedTab = _h === void 0 ? 0 : _h;
    var navigate = useNavigate();
    var location = useLocation();
    var navConfig = NavigationConfig;
    var dispatch = useDispatch();
    var userBasicInfo = useSelector(function (store) { return store.User; });
    var userData = (_b = userBasicInfo === null || userBasicInfo === void 0 ? void 0 : userBasicInfo.userData) !== null && _b !== void 0 ? _b : null;
    var rolePermissions = (_c = userData === null || userData === void 0 ? void 0 : userData.RolePermissions) !== null && _c !== void 0 ? _c : [];
    var _j = useState(function () {
        var stored = localStorage.getItem('leftMenuOpen');
        return stored === null ? true : stored === 'true';
    }), isOpen = _j[0], setIsOpen = _j[1];
    var closeLeftMenuSignal = useSelector(function (store) { return store.App.closeLeftMenuSignal; });
    var hasMountedCloseSignal = React.useRef(false);
    useEffect(function () {
        if (!hasMountedCloseSignal.current) {
            hasMountedCloseSignal.current = true;
            return;
        }
        setIsOpen(false);
        localStorage.setItem('leftMenuOpen', 'false');
    }, [closeLeftMenuSignal]);
    var _k = useState(null), expandedIdx = _k[0], setExpandedIdx = _k[1];
    var _l = useState([]), expandedSubKeys = _l[0], setExpandedSubKeys = _l[1];
    var _m = useState(null), selectedTopIdx = _m[0], setSelectedTopIdx = _m[1];
    var _o = useState(null), selectedSubKey = _o[0], setSelectedSubKey = _o[1];
    var _p = useState(null), profileAnchorEl = _p[0], setProfileAnchorEl = _p[1];
    var _q = useState(false), isLogoutPopupOpen = _q[0], setIsLogoutPopupOpen = _q[1];
    var hasViewPermission = useCallback(function (permissionKey) {
        if (!rolePermissions || rolePermissions.length === 0)
            return false;
        var exactMatch = rolePermissions.find(function (permission) { return permission.PermissionKey === permissionKey; });
        if (exactMatch && isAnyActionEnabled(exactMatch))
            return true;
        var hasEnabledChild = rolePermissions.some(function (permission) {
            return permission.PermissionKey.startsWith(permissionKey + ':') &&
                isAnyActionEnabled(permission);
        });
        if (hasEnabledChild)
            return true;
        return false;
    }, [rolePermissions]);
    var tabsData = useMemo(function () {
        if (!userData)
            return [];
        var baseTabsData = [
            { label: 'User Management', path: navConfig.UserManagement, permissionKey: 'USER_MANAGMENT' },
            {
                label: 'Application Management',
                permissionKey: 'APPLICATION_MANAGMENT',
                submenuItems: [
                    {
                        label: 'Backlog Queue',
                        permissionKey: 'APPLICATION_MANAGMENT:BACKLOG_QUEUE',
                        path: navConfig.BacklogManagement,
                        additionalPaths: [navConfig.BacklogAppDetails],
                    },
                    {
                        label: 'Funding Queue',
                        permissionKey: 'APPLICATION_MANAGMENT:FUNDING_QUEUE',
                        path: navConfig.FundingLogManagement,
                    },
                ],
            },
            { label: 'Marketing Content', path: navConfig.MarketingConent, permissionKey: 'MARKETING_CONTENT' },
            {
                label: 'Administrator',
                permissionKey: 'ADMINISTRATOR',
                submenuItems: [
                    {
                        label: 'Admin Management',
                        permissionKey: 'ADMINISTRATOR:ADMIN_MGMT',
                        path: navConfig.AdminManagement,
                    },
                    {
                        label: 'Portal Setup',
                        permissionKey: 'ADMINISTRATOR:PORTAL_SETUP',
                        path: navConfig.DealerManagement,
                    },
                    {
                        label: 'Global Settings',
                        permissionKey: 'ADMINISTRATOR:GLOBAL_SETTINGS',
                        path: navConfig.InsuranceConfig,
                    },
                    { label: 'Resubmit', path: navConfig.ResubmitApplication, permissionKey: 'ADMINISTRATOR:RESUBMIT_APPLICATION' },
                ],
            },
            {
                label: 'Customer Portal',
                permissionKey: 'CUSTOMER_PORTAL',
                submenuItems: __spreadArray(__spreadArray([
                    { label: 'Dashboard', path: navConfig.CustomerPortalDashboard, permissionKey: 'CUSTOMER_PORTAL' },
                    { label: 'Customer Management', path: navConfig.CustomerPortalUserManagement, permissionKey: 'CUSTOMER_PORTAL' },
                    { label: 'Payment Management', path: navConfig.PaymentManagement, permissionKey: 'CUSTOMER_PORTAL' },
                    { label: 'Document Management', path: navConfig.DocumentManagement, permissionKey: 'CUSTOMER_PORTAL' },
                    { label: 'Support Management', path: navConfig.CustomerPortalSupportManagement, permissionKey: 'CUSTOMER_PORTAL' },
                    { label: 'Brand Customization', path: navConfig.BrandCustomization, permissionKey: 'CUSTOMER_PORTAL' }
                ], (!isProduction ? [{ label: 'Chatbot FAQs', path: navConfig.CustomerPortalChatbotFaqs, permissionKey: 'CUSTOMER_PORTAL:BRAND_CUSTOMIZATION:CHATBOT_FAQS' }] : []), true), [
                    { label: 'Audit Logs', path: navConfig.CustomerPortalAuditLogs, permissionKey: 'CUSTOMER_PORTAL' },
                    { label: 'Admin Registration', path: navConfig.CustomerPortalRegistrationManagement, permissionKey: 'CUSTOMER_PORTAL' }
                ], false),
            },
        ];
        return filterMenuItemsByPermissions(baseTabsData, hasViewPermission);
    }, [hasViewPermission, navConfig, userData]);
    var activeTopIdx = useMemo(function () {
        var _a;
        for (var i = 0; i < tabsData.length; i++) {
            var tab = tabsData[i];
            if (isPathActive(location.pathname, tab.path, tab.additionalPaths))
                return i;
            if ((_a = tab.submenuItems) === null || _a === void 0 ? void 0 : _a.length) {
                var hasMatch = isPathInTree(location.pathname, tab.submenuItems);
                if (hasMatch)
                    return i;
            }
        }
        return null;
    }, [location.pathname, tabsData]);
    useEffect(function () {
        if (activeTopIdx !== null) {
            setExpandedIdx(activeTopIdx);
            setSelectedTopIdx(activeTopIdx);
        }
    }, [activeTopIdx]);
    var focusedTopIdx = selectedTopIdx !== null
        ? selectedTopIdx
        : (expandedIdx !== null ? expandedIdx : activeTopIdx);
    useEffect(function () {
        var _a, _b;
        if (activeTopIdx === null)
            return;
        var topItems = (_b = (_a = tabsData[activeTopIdx]) === null || _a === void 0 ? void 0 : _a.submenuItems) !== null && _b !== void 0 ? _b : [];
        setExpandedSubKeys(collectActiveBranchKeys(location.pathname, topItems, "".concat(activeTopIdx)));
        var routeMatchedSubKey = findActiveSubKey(location.pathname, topItems, "".concat(activeTopIdx));
        setSelectedSubKey(routeMatchedSubKey);
    }, [activeTopIdx, location.pathname, tabsData]);
    var handleTopClick = useCallback(function (tab, idx) {
        var _a;
        setSelectedTopIdx(idx);
        if (!((_a = tab.submenuItems) === null || _a === void 0 ? void 0 : _a.length) && tab.path) {
            setExpandedSubKeys([]);
            navigate(tab.path, tab.state ? { state: tab.state } : undefined);
            return;
        }
        if (!isOpen) {
            setIsOpen(true);
            localStorage.setItem('leftMenuOpen', 'true');
            setExpandedIdx(idx);
            setExpandedSubKeys([]);
        }
        else {
            var shouldCollapse = expandedIdx === idx;
            setExpandedIdx(shouldCollapse ? null : idx);
            setExpandedSubKeys([]);
        }
    }, [expandedIdx, isOpen, navigate]);
    var handleSubClick = useCallback(function (sub, key, topIdx) {
        var _a, _b;
        setSelectedTopIdx(topIdx);
        if ((_a = sub.submenuItems) === null || _a === void 0 ? void 0 : _a.length) {
            setSelectedSubKey(null);
            setExpandedSubKeys(function (prev) {
                return prev.includes(key) ? prev.filter(function (k) { return k !== key; }) : __spreadArray(__spreadArray([], prev, true), [key], false);
            });
            return;
        }
        setSelectedSubKey(key);
        if ((_b = sub.permissionKey) === null || _b === void 0 ? void 0 : _b.startsWith('APPLICATION_MANAGMENT:'))
            fetchAppMetadata();
        if (sub.path)
            navigate(sub.path, sub.state ? { state: sub.state } : undefined);
    }, [navigate]);
    var isSubActive = useCallback(function (key) {
        return selectedSubKey === key;
    }, [selectedSubKey]);
    var isProfilePopoverOpen = Boolean(profileAnchorEl);
    var handleFooterClick = useCallback(function (event) {
        setProfileAnchorEl(event.currentTarget);
    }, []);
    var handleProfilePopoverClose = useCallback(function () {
        setProfileAnchorEl(null);
    }, []);
    var handleLogout = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4, dispatch(loginSignup_asyncActions.logout())];
                case 1:
                    response = _b.sent();
                    if (((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.statusCode) === 200) {
                        setIsLogoutPopupOpen(false);
                        handleProfilePopoverClose();
                        navigate(NavigationConfig.Account.Login, { replace: true });
                        window.location.reload();
                    }
                    return [2];
            }
        });
    }); }, [dispatch, handleProfilePopoverClose, navigate]);
    var handleLogoutClick = useCallback(function () {
        setIsLogoutPopupOpen(true);
    }, []);
    var handleLogoutPopupClose = useCallback(function () {
        setIsLogoutPopupOpen(false);
    }, []);
    var renderSubMenuItems = function (items, topIdx, isCustomerPortal, level, parentPath) {
        return items.map(function (sub, subIdx) {
            var _a, _b;
            var key = "".concat(parentPath, "-").concat(subIdx);
            var isExpanded = expandedSubKeys.includes(key);
            var hasChildren = !!((_a = sub.submenuItems) === null || _a === void 0 ? void 0 : _a.length);
            return (React.createElement(React.Fragment, { key: key },
                React.createElement("div", { className: "menu-subItem".concat(isSubActive(key) ? ' active' : ''), onClick: function () { return handleSubClick(sub, key, topIdx); }, style: { paddingLeft: "".concat(32 + level * 20, "px") } },
                    React.createElement("span", { className: "subMenu-iconSlot" }, getIcon(sub.label, isCustomerPortal)),
                    React.createElement(Typography, { variant: 'body2', className: "subMenu-label" }, sub.label),
                    hasChildren && (React.createElement("span", { className: "menu-chevron", style: { marginLeft: 'auto' } },
                        React.createElement(ExpandMoreIcon, { sx: {
                                transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                                transition: 'transform 0.2s ease',
                                color: '#fff'
                            } })))),
                hasChildren && (React.createElement(Collapse, { in: isExpanded, timeout: "auto", unmountOnExit: true }, renderSubMenuItems((_b = sub.submenuItems) !== null && _b !== void 0 ? _b : [], topIdx, isCustomerPortal, level + 1, key)))));
        });
    };
    var userName = userData
        ? "".concat((_d = userData.firstName) !== null && _d !== void 0 ? _d : '', " ").concat((_e = userData.lastName) !== null && _e !== void 0 ? _e : '').trim() || userData.email
        : '';
    var userEmail = (_f = userData === null || userData === void 0 ? void 0 : userData.email) !== null && _f !== void 0 ? _f : '--';
    var userPhone = (userData === null || userData === void 0 ? void 0 : userData.PhoneNumber)
        ? "+1 ".concat(formatPhoneNumber(userData.PhoneNumber))
        : '--';
    if (!userData)
        return null;
    return (React.createElement(SideMenuWrapper, { isOpen: isOpen },
        React.createElement("div", { className: "menu-logo" },
            React.createElement("div", { className: "menu-logoBrand" },
                React.createElement("span", { className: "icon-Aux-Logo" }),
                React.createElement(Typography, { variant: 'h6', className: "menu-logoText" }, "Auxcap")),
            React.createElement("button", { type: "button", className: "menu-toggleBtn", "aria-label": isOpen ? 'Collapse side menu' : 'Expand side menu', onClick: function () {
                    setIsOpen(function (prev) {
                        if (prev) {
                            setExpandedIdx(null);
                            setExpandedSubKeys([]);
                        }
                        var next = !prev;
                        localStorage.setItem('leftMenuOpen', String(next));
                        return next;
                    });
                } },
                React.createElement("span", { className: isOpen ? "icon-first_page" : "icon-Aux-Logo" }))),
        React.createElement("div", { className: "menu-nav" }, tabsData.map(function (tab, idx) {
            var isActive = focusedTopIdx === idx;
            var isExpanded = expandedIdx === idx;
            var isCustomerPortal = tab.label === 'Customer Portal';
            return (React.createElement(React.Fragment, { key: tab.label },
                React.createElement(Tooltip, { title: !isOpen ? tab.label : '', placement: "right", arrow: true },
                    React.createElement("div", { className: "menu-item".concat(isActive ? ' active' : ''), onClick: function () { return handleTopClick(tab, idx); } },
                        getIcon(tab.label),
                        React.createElement(Typography, { variant: 'body2', className: "menu-label" }, tab.label),
                        tab.submenuItems && (React.createElement("span", { className: "menu-chevron" },
                            React.createElement(ExpandMoreIcon, { sx: {
                                    transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                                    transition: 'transform 0.2s ease',
                                    color: '#fff'
                                } }))))),
                tab.submenuItems && isOpen && (React.createElement(Collapse, { in: isExpanded, timeout: "auto", unmountOnExit: true }, renderSubMenuItems(tab.submenuItems, idx, isCustomerPortal, 0, "".concat(idx))))));
        })),
        React.createElement("div", { className: "menu-footer", role: "button", tabIndex: 0, onClick: handleFooterClick, onKeyDown: function (event) {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    handleFooterClick(event);
                }
            } },
            React.createElement(Avatar, { sx: { width: 32, height: 32, fontSize: 13, flexShrink: 0, bgcolor: 'rgba(255,255,255,0.2)' } }, userName ? userName[0].toUpperCase() : 'U'),
            React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column', ml: 1, overflow: 'hidden', minWidth: 0 } },
                React.createElement("span", { className: "menu-footerText" }, userName),
                React.createElement(Typography, { component: "span", sx: {
                        alignSelf: 'flex-start',
                        mt: 0.25,
                        px: 0.8,
                        py: 0.15,
                        border: "1px solid ".concat(baseColors.greyPreset[30]),
                        borderRadius: '999px',
                        color: baseColors.fullWhite,
                        fontSize: '10px',
                        lineHeight: 1.5,
                        fontWeight: 800,
                        maxWidth: '100%',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    } }, (userData === null || userData === void 0 ? void 0 : userData.RoleDescription) || '--'))),
        React.createElement(Popover, { open: isProfilePopoverOpen, anchorEl: profileAnchorEl, onClose: handleProfilePopoverClose, anchorOrigin: { vertical: 'bottom', horizontal: 'right' }, transformOrigin: { vertical: 'bottom', horizontal: 'left' }, className: "menu-profilePopover", slotProps: {
                paper: {
                    sx: {
                        minWidth: 260,
                        borderRadius: '6px',
                        boxShadow: '0px 8px 24px rgba(24, 39, 75, 0.2)',
                        ml: '4px',
                        mb: '2px',
                        overflow: 'hidden',
                    },
                },
            } },
            React.createElement(Box, { sx: { backgroundColor: baseColors.fullWhite } },
                React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', gap: '10px', px: '14px', py: '10px' } },
                    React.createElement(Avatar, { sx: { width: 32, height: 32, fontSize: 13, flexShrink: 0, bgcolor: '#E8F0FF', color: baseColors.bluePreset[10] } }, userName ? userName[0].toUpperCase() : 'U'),
                    React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column', ml: 1, overflow: 'hidden', minWidth: 0 } },
                        React.createElement(Typography, { sx: { color: baseColors.fullBlack, fontSize: 16, lineHeight: '22px', fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } }, userName || '--'),
                        React.createElement(Typography, { sx: { color: baseColors.fullBlack, fontSize: 10, lineHeight: '22px', fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } }, (userData === null || userData === void 0 ? void 0 : userData.RoleDescription) || ''))),
                React.createElement(Divider, null),
                React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', gap: '10px', px: '14px', py: '10px' } },
                    React.createElement(MailOutlineIcon, { sx: { color: baseColors.fullBlack, fontSize: 18 } }),
                    React.createElement(Typography, { sx: { color: baseColors.fullBlack, fontSize: 16, lineHeight: '22px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } }, userEmail)),
                React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', gap: '10px', px: '14px', py: '10px' } },
                    React.createElement(LocalPhoneOutlinedIcon, { sx: { color: baseColors.fullBlack, fontSize: 18 } }),
                    React.createElement(Typography, { sx: { color: baseColors.fullBlack, fontSize: 16, lineHeight: '22px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } }, userPhone)),
                React.createElement(Divider, null),
                React.createElement(Box, { onClick: handleLogoutClick, sx: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        px: '14px',
                        py: '10px',
                        cursor: 'pointer',
                        '&:hover': {
                            backgroundColor: '#0D9489',
                        },
                    } },
                    React.createElement(LogoutOutlinedIcon, { sx: { color: baseColors.fullBlack, fontSize: 18 } }),
                    React.createElement(Typography, { sx: { color: baseColors.fullBlack, fontSize: 16, lineHeight: '22px' } }, "Logout")))),
        React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.LOGOUT_WARNING, titleText: 'Are you sure?', message: 'Are you sure you want to Logout?', acceptBtnText: 'Yes', denyBtnText: 'No', acceptCallBack: handleLogout, denyCallBack: handleLogoutPopupClose, cancelCallBack: handleLogoutPopupClose, open: isLogoutPopupOpen })));
};
export default LeftMenu;
